import {
  CLEAR_SURVEY,
  NEXT_SCREEN,
  PREVIOUS_SCREEN,
  FETCH_PROFILE_SURVEY_DATA,
  FETCH_PROFILE_SURVEY_DATA_SUCCESS,
  UPDATE_PROFILE_SURVEY_BASICS_SUCCESS,
  ADD_PROFILE_SURVEY_INTERESTS_SUCCESS,
  DELETE_PROFILE_SURVEY_INTEREST_SUCCESS,
  ADD_PROFILE_SURVEY_CONDITION_SUCCESS,
  DELETE_PROFILE_SURVEY_CONDITION_SUCCESS,
  UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS,
  ADD_PROFILE_SURVEY_TREATMENT_SUCCESS,
  DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS,
  UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS,
} from './actionTypes';

export const initialState = {
  currentScreen: null,
  history: [],
  profileData: {
    isLoading: true,
    basics: {},
    interests: [],
    conditions: [],
  },
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_SURVEY:
      return initialState;
    case NEXT_SCREEN:
      let newHistory = [...state.history, state.currentScreen];

      // The history array shouldn't have either ConditionDetails or doubles.
      // As ConditionDetails screen returns to Conditions screen, this if statement takes care of both those cases:
      // If nextScreen is the last screen in history, remove it from history
      if (state.history[state.history.length - 1] === action.nextScreen) {
        newHistory = state.history.slice(0, state.history.length - 1);
      }

      return {
        ...state,
        currentScreen: action.nextScreen,
        history: newHistory,
      };
    case PREVIOUS_SCREEN:
      return {
        ...state,
        currentScreen: state.history[state.history.length - 1],
        history: state.history.slice(0, state.history.length - 1),
      };
    case FETCH_PROFILE_SURVEY_DATA:
      return {
        ...state,
        profileData: {
          isLoading: true,
        },
      };
    case FETCH_PROFILE_SURVEY_DATA_SUCCESS:
      const { basics, conditions, interests } = action.data;
      return {
        ...state,
        profileData: {
          basics,
          conditions,
          interests,
          isLoading: false,
        },
      };
    case UPDATE_PROFILE_SURVEY_BASICS_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          basics: action.data, // has all basics data
        },
      };
    case ADD_PROFILE_SURVEY_INTERESTS_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          interests: action.interests,
        },
      };
    case DELETE_PROFILE_SURVEY_INTEREST_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          interests: state.profileData.interests.filter(x => x.id !== action.id),
        },
      };
    case ADD_PROFILE_SURVEY_CONDITION_SUCCESS:
      const existingCondition = state.profileData.conditions.find(x => x.id === action.condition.id);
      let conditionsArray;
      if (existingCondition) {
        conditionsArray = [existingCondition, ...state.profileData.conditions.filter(x => x.id !== action.condition.id)];
      } else {
        conditionsArray = [action.condition, ...state.profileData.conditions];
      }
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: conditionsArray,
        },
      };
    case DELETE_PROFILE_SURVEY_CONDITION_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: state.profileData.conditions.filter(x => x.id !== action.id),
        },
      };
    case UPDATE_PROFILE_SURVEY_CONDITION_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: state.profileData.conditions.map((x => x.id === action.condition.id ? {...action.condition, treatments: x.treatments} : x)),
        },
      };
    case ADD_PROFILE_SURVEY_TREATMENT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: state.profileData.conditions.map((condition) => {
            if (condition.id === action.id) {
              const existingTreatment = condition.treatments.find(x => x.id === action.treatment.id);
              if (existingTreatment) {
                return {...condition, treatments: [existingTreatment, ...condition.treatments.filter(x => x.id !== action.treatment.id)]};
              } else {
                return {...condition, treatments: [action.treatment, ...condition.treatments]};
              }
            } else {
              return condition;
            }
          }),
        },
      };
    case DELETE_PROFILE_SURVEY_TREATMENT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: state.profileData.conditions.map((x) => {
            return (
              x.id === action.conditionId
                ? {...x, treatments: x.treatments.filter(t => t.id !== action.id)}
                : x
            );
          }),
        },
      };
    case UPDATE_PROFILE_SURVEY_TREATMENT_SUCCESS:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          conditions: state.profileData.conditions.map((x) => {
            return (
              x.id === action.conditionId
                ? {...x, treatments: x.treatments.map(t => t.id === action.id ? action.data : t)}
                : x
            );
          }),
        },
      };
  }
  return state;
}
